export default {
  business: state => state.business,
  devices: state => state.devices
}



// WEBPACK FOOTER //
// ./src/store/modules/location/getters.js